import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import {useCollectionOnce} from "react-firebase-hooks/firestore";
import {collection} from "firebase/firestore";
import Alert from "@mui/material/Alert";
import {getFirebase} from "../../config/firebase.config";
import Loading from "../common/Loading";
import Button from "@mui/material/Button";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuItem from "@mui/material/MenuItem";
import KeyIcon from '@mui/icons-material/Key';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import {StyledMenu} from "../common/StyledMenu";
import Divider from "@mui/material/Divider";
import {Link as RouterLink} from "react-router-dom";

export default function EmployeeList() {
    const {firestore} = getFirebase();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const [value, loading, error] = useCollectionOnce(
        collection(firestore, 'employees'),
        {
            snapshotListenOptions: {includeMetadataChanges: true},
        }
    );
    if (loading) {
        return <Loading/>
    }
    return (
        <React.Fragment>
            <TableContainer component={Paper} sx={{maxHeight: 450}}>
                {error && <Alert severity="error">{error.message}</Alert>}
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>EmpId</TableCell>
                            <TableCell>Phone</TableCell>
                            <TableCell>Address</TableCell>
                            <TableCell>Since</TableCell>
                            <TableCell>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {value && value.docs.map((doc) => (
                            <TableRow key={doc.id}>
                                <TableCell>{doc.data().empName}</TableCell>
                                <TableCell>{doc.data().email}</TableCell>
                                <TableCell>{doc.data().empId}</TableCell>
                                <TableCell>{doc.data().empPhone}</TableCell>
                                <TableCell>{doc.data().empAddress}</TableCell>
                                <TableCell>{doc.data().timestamp.toDate().toLocaleString()}</TableCell>
                                <TableCell>
                                    <Button
                                        id="demo-customized-button"
                                        aria-controls={open ? 'demo-customized-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={open ? 'true' : undefined}
                                        variant="contained"
                                        disableElevation
                                        onClick={handleClick}
                                        endIcon={<KeyboardArrowDownIcon/>}
                                    >
                                        Options
                                    </Button>
                                    <StyledMenu
                                        id="demo-customized-menu"
                                        MenuListProps={{
                                            'aria-labelledby': 'demo-customized-button',
                                        }}
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleClose}
                                    >
                                        <MenuItem onClick={handleClose} component={RouterLink}
                                                  to={`/dashboard/employees/${doc.data().uid}`} disableRipple>
                                            <OpenInNewIcon/>
                                            Open
                                        </MenuItem>
                                        <MenuItem onClick={handleClose} disableRipple>
                                            <FileCopyIcon/>
                                            File MissedEVV
                                        </MenuItem>
                                        <Divider sx={{my: 0.5}}/>
                                        <MenuItem onClick={handleClose} disableRipple>
                                            <KeyIcon/>
                                            Reset password
                                        </MenuItem>
                                    </StyledMenu>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </React.Fragment>
    );
}
